<template>
  <div id="app">
    <video :src="config.video" autoplay loop
      :class="{ 'overflow-width-video': overflow === 'width', 'overflow-height-video': overflow === 'height', 'center-video': !overflow }"/>
    <h1 class="logo-box">
      <img :src="config.title" />
    </h1>
    <div class="table-wrapper">
      <iframe hidden @error="error()" @load="load()" src="https://admin-alilang.alibaba-inc.com/checkpreload.htm" />
      <div :class="[config.align === 'center' ? 'login-box' : 'login-box-left']">
        <h2>选择快捷登录方式</h2>
        <ul v-bind:class="[config.style === 'inline' ? 'inline-ul' : 'block-ul']">
          <li class="platform-li" v-for="item in config.platforms"
            v-on:click="jumpTo(item)" 
            v-if="getEntryce(item)"
            v-on:mouseover="setBackground(item)"
            v-on:mouseout="setBackground()"
            :style="{ border: config.style === 'block' ? '1px solid ' + item.color : 'none' }">
            <img :src="item.imgSrc" />
            <span class="platform-name">{{ item.name }}</span>
            <span class="platform-hint">{{ item.hint }}</span>
          </li>
        </ul>
        <div class="other-login">
          <label>其他登录方式：</label>
          <ul>
            <li v-for="item in config.otherLogin"
              v-if="getEntryce(item)">
              <a :href="item.url" >{{ item.name }}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'App',
  data: function(){
    return {
      config: window.config,
      inner: false,
      timeoutId: '',
      overflow: false
    }
  },
  mounted: function () {
    this.timeoutId = setTimeout(() => {
      this.inner = false;
    }, 100);
    if(document.body.clientWidth > 2500 && document.body.clientHeight > 1200){
      this.overflow = document.body.clientWidth/2500 > document.body.clientHeight/1200 ? 'width' : 'height'
    } else {
      if(document.body.clientWidth > 2500){
        this.overflow = 'width';
      }
      if(document.body.clientHeight > 1200){
        this.overflow = 'height';
      }
    }
  },
  methods:{
    getEntryce: function(item){
      return item.inner ? this.inner : true;
    },
    error: function(){
      this.inner = false;
      clearTimeout(this.timeoutId);
    },
    load: function(){
      this.inner = true;
      clearTimeout(this.timeoutId);
    },
    jumpTo: (item) => {
      location.href = item.url;
    },
    setBackground: (item) => {
      if (item) {
        let colors = item.color.split(",");
        colors[3] = "0.08)";
        if (event.path[0].className !== 'platform-li') {
          event.target.parentNode.style.background = colors.join(",");  
        } else {
          event.target.style.background = colors.join(",");  
        }
      } else {
        if (event.path[0].className !== 'platform-li') {
          event.target.parentNode.style.background = 'transparent';
        } else {
          event.target.style.background = 'transparent';
        }
      }
    }
  }
}
</script>

<style>
@import './styles/base.css';
body{
  height: 100%;
  overflow: hidden;
}
#app {
  background-image: url(http://gw.alicdn.com/mt/LB1SKRRmv5TBuNjSspmXXaDRVXa-2500-1200.png);
  display: table;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.overflow-video{

}
.center-video{
  position: absolute;
  left: 50%;
  margin-left: -1250px;
  margin-top: -500px;
  top: 50%;
  width: 2500px
}
.overflow-width-video{
  width: 100%;
}
.overflow-height-video{
  height: 100%;
}
video{
  position: absolute;
  left: 50%;
  margin-left: -720px;
  margin-top: -450px;
  top: 50%;
  width: 1440px
}
.logo-box{
  position: absolute;
  width: 100%;
  height: 90px;
  line-height: 90px;
  padding: 0 40px;
  box-sizing: border-box;
  top: 0;
  background: rgba(255,255,255,0.1);
}
.relative-img{
  position: relative;
}
.absolute-img{
  position: fixed;
  left: 40px;
  height: 60px;
  top: 15px;
}
.table-wrapper{
  display: table-cell;
  vertical-align: middle;
}
.login-box{
  border-radius: 6px;
  position: relative;
  left: 50%;
  background: #FFFFFF;
  opacity: 0.9000000357627869;
  box-shadow: 0px 2px 6px 0px rgba(153,153,153,0.50);
  width: 380px;
  padding: 40px;
  box-sizing: border-box;
  margin-left: -190px;
}
.login-box-left{
  border-radius: 6px;
  position: relative;
  left: 65vw;
  background: #FFFFFF;
  opacity: 0.9000000357627869;
  box-shadow: 0px 2px 6px 0px rgba(153,153,153,0.50);   
  width: 360px;
  padding: 40px;
  box-sizing: border-box;
}
h2{
  font-family: PingFangSC-Regular;
  color: #666666;
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  margin-bottom: 30px;
}
.block-ul{
  padding: 10px 0;
}
.block-ul li{
  height: 50px;
  line-height: 30px;
  padding: 10px 20px;
  font-size: 14px;
  box-sizing: border-box;
  cursor: pointer;
}
.block-ul li:not(:last-child){
  margin-bottom: 30px;
}
.block-ul li img{
  width: 32px;
  margin-right: 50px;
}
.block-ul li .platform-hint{
  display: block;
  margin-top: 6px;
  width: 100%;
  text-align: right;
  margin-left: 22px;
  font-size: 10px;
  color: #999999;
}
.inline-ul{
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  padding: 10px 0;
  box-sizing: border-box;
  grid-template-rows: 75px;
  grid-row-gap: 30px;
  justify-items: center;
  align-items: center;
}
.inline-ul li{
  cursor: pointer;
  text-align: center;
  position: relative;
  font-size: 14px;
  width: 100%;
}
.inline-ul li img{
  vertical-align: middle;
  height: 28px;
  margin-top: 10px;
  margin-bottom: 15px;
}
.inline-ul li .platform-name{
  margin-bottom: 10px;
  display: block;
}
.inline-ul li .platform-hint{
  font-size: 10px;
  position: absolute;
  width: 100%;
  display: block;
  white-space: nowrap;
  left: 0;
  color: #999999;
  margin-top: -2px;
}
.other-login{
  margin-top: 30px;
  font-size: 12px;
  padding-left: 85px;
}
.other-login label{
  left: 40px;
  position: absolute;
  color: #666666;
}
.other-login ul{
  display: inline-block;
}
.other-login ul li a{
  color: #00c1de;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/App.vue